import React from 'react';
import classNames from 'classnames';
import { Service } from '../../../../../../hoc/context/product/configuration-model';
import { RichText } from '../../../../../../hoc/components';
import useTranslation from '../../../../../../../hooks/useTranslation';

const CardLeftView: React.FC<{
	service: Service;
	defaultClassName: string;
	titleClassName: string;
	printMode?: boolean;
}> = ({ service, defaultClassName, titleClassName, printMode = false }) => {
	const { t } = useTranslation();
	return (
		<div
			className={classNames(defaultClassName, {
				'bg-brand py-5': !printMode,
			})}>
			<div
				className={classNames('flex flex-col', {
					'text-font-contrast': !printMode,
					'text-novartis-font': printMode,
				})}>
				<div className={classNames(titleClassName)}>
					<RichText html={t(`services.${service.name}.card`)} />
				</div>
			</div>
		</div>
	);
};

export default CardLeftView;
